import { useState, useCallback, useEffect } from 'react'
import axios from "axios"
import { useNavigate } from "react-router-dom";

const Authentication = (token) => {


    const [identification, setIdentification] = useState(null)
    const navigate = useNavigate()

    // Getdata
    const getData = useCallback(() => {

        if (!!token) {

            axios({
                method: 'post',
                url: `https://www.phoenix-md.com/api/authentication`,
                params: {

                },
                headers: {
                    "Content-Type": "application/json",
                    Authorization: token
                }
            }).then((res) => {

                if (!!res.data.identification) {

                    if (res.data.identification.level.value !== 1 && res.data.identification.level.value !== 2) {
                        navigate('/login')

                        return
                    }

                    setIdentification(res.data.identification)

                }
                else {

                    navigate('/login')

                }

            }).catch((error) => {

                console.log(error.message)
                navigate('/login')

            })


        }

    }, [token, setIdentification, navigate])
    useEffect(() => {
        if (!identification) {
            getData()
        }
    }, [identification, getData])

    return identification

}

export default Authentication
